import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasW : false,
  // Sahip olunan VIN / plaka çözümleyici ürünleri (LicenseProductId 49, 50)
  resolverProductIds: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setHasW(state, action) {
        state.hasW = action.payload;
    },
    setResolverProductIds(state, action) {
        state.resolverProductIds = action.payload;
    },
    addResolverProductId(state, action) {
        if (!state.resolverProductIds.includes(action.payload)) {
            state.resolverProductIds.push(action.payload);
        }
    },
  },
});

export const { setHasW, setResolverProductIds, addResolverProductId } = authSlice.actions;
export default authSlice.reducer;
